import { gql } from "@apollo/client";

import { caseSummaryFragment } from "src/graphql/anti-fraud/fragments/CaseSummaryFragment";
import { shortAlertFragment } from "src/graphql/anti-fraud/fragments/ShortAlertFragment";
import { shortCaseElementFragment } from "src/graphql/anti-fraud/fragments/ShortCaseElementFragment";

export const alertSummaryFragment = gql`
  fragment AlertSummaryFragment on Alert {
    ...ShortAlertFragment
    nbrOfIdentifiedCases
    caseVersions {
      creation {
        ...CaseSummaryFragment
      }
      current {
        ...CaseSummaryFragment
      }
      validation {
        ...CaseSummaryFragment
      }
    }
    scenarioExecutionResult {
      globalScore
      case {
        id
        elements {
          ...ShortCaseElementFragment
        }
      }

      scenarioVersion {
        id
        name
        scenario {
          id
          name
        }
      }
    }
  }
  ${caseSummaryFragment}
  ${shortCaseElementFragment}
  ${shortAlertFragment}
`;
